import { Controller } from '@hotwired/stimulus';
import { startAuthentication } from '@simplewebauthn/browser';

export default class extends Controller {
  static targets = ['credential', 'form'];

  async authenticate(event) {
    event.preventDefault();

    try {
      const options = await this.makeOptionsLoginRequest();
      const assertion = await startAuthentication(options);

      this.credentialTarget.value = JSON.stringify(assertion);
      this.formTarget.submit();
    } catch (error) {
      console.error('Error during authentication:', error);
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content;
  }

  async makeOptionsLoginRequest() {
    const response = await fetch('/passkey/options_login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken,
      },
      credentials: 'same-origin',
    });

    return response.json();
  }
}
